/**
 * Learn more about deep linking with React Navigation
 * https://reactnavigation.org/docs/deep-linking
 * https://reactnavigation.org/docs/configuring-links
 */

import { LinkingOptions } from '@react-navigation/native';
import * as Linking from 'expo-linking';

import { RootStackParamList } from './navigationTypes';

const linking: LinkingOptions<RootStackParamList> = {
  prefixes: [Linking.createURL('/')],
  config: {
    screens: {
      Survey: {
        path: 'survey/:id?',
        parse: {
          id: (id) => `${id}`,
        },
        stringify: {
          id: (id) => id,
        },
      },
      Refer: {
        path: 'refer/:id?',
        parse: {
          id: (id) => `${id}`,
        },
        stringify: {
          id: (id) => id,
        },
      },
      ReferralVerification: 'verify-referral',
      Modal: 'modal',
      Home: 'home',
      Subscription: 'subscription',
      Email: 'email',
      Checkout: 'checkout',
      Upgrade: 'upgrade',
      CheckoutRedirect: 'checkout-success',
      CreateAccount: 'create-account',
      DownloadApp: 'download',
      Register: 'register',
      ExpertReviewSignUp: 'newyears',
      Beta: 'beta',
      Terms: 'terms',
      Privacy: 'privacy',
      WhatIsSnapCalorie: 'what-is-snapcalorie',
      HowMuchDoesSnapCalorieCost: 'how-much-does-snapcalorie-cost',
      DoesSnapCalorieWork: 'does-snapcalorie-work',
      NotFound: '*',
    },
  },
};

export default linking;
